import * as moment from 'moment';
import { Store } from 'flux/utils';
import AssignmentDispatcher from '../dispatchers/AssignmentDispatcher';

import { getAssignmentsInRange, getEditorAssignments } from '../PoolAPI';

export async function fetchAssignmentForEditor(editor: string) {
  const r = await getEditorAssignments(
    editor,
    moment()
      .subtract(30, 'days')
      .format('YYYY-MM-DD'),
    moment()
      .add(30, 'days')
      .format('YYYY-MM-DD')
  );
  if (r.status >= 400) {
    return;
  }

  const j = await r.json();
  AssignmentDispatcher.handleUpdateAssignmentForEditor(editor, j);
}

export async function fetchAssignmentsInRange(
  startDate: string,
  endDate: string
) {
  const r = await getAssignmentsInRange(startDate, endDate);
  if (r.status >= 400) {
    return;
  }

  const j = await r.json();
  AssignmentDispatcher.handleUpdateAssignmentForDates(j);
}

class AssignmentStore extends Store<{}> {
  private editorAssignments = {};

  getAssignmentsForEditor(editor: string): AssignmentsByDate | undefined {
    const results = this.editorAssignments[editor];
    if (results === undefined) {
      fetchAssignmentForEditor(editor);
    }
    return this.editorAssignments[editor];
  }

  getAssignmentsForDate(date: string): { [editor: string]: Assignment } {
    const assignments = {};
    let datesMissing = false;
    Object.keys(this.editorAssignments).map((editor: string) => {
      if (this.editorAssignments[editor] !== undefined) {
        assignments[editor] = this.editorAssignments[editor][date];
      } else {
        datesMissing = true;
      }
    });
    if (datesMissing) {
      fetchAssignmentsInRange(
        moment(date)
          .subtract(7, 'days')
          .format('YYYY-MM-DD'),
        date
      );
    }
    return assignments;
  }

  __onDispatch(payload: DispatchPayload) {
    if (payload.source === 'UPDATE_EDITOR_ASSIGNMENT') {
      const editor = payload.output.editor;
      const assignments = payload.output.assignments;
      const oldEditorAssignments = this.editorAssignments[editor];
      if (oldEditorAssignments === undefined) {
        this.editorAssignments[editor] = assignments;
      } else {
        this.editorAssignments[editor] = {
          ...oldEditorAssignments,
          ...assignments,
        };
      }
      this.__emitChange();
    } else if (payload.source === 'UPDATE_ALL_ASSIGNMENTS') {
      Object.keys(payload.output.assignments).map((editor: string) => {
        const oldEditorAssignments = this.editorAssignments[editor];
        if (oldEditorAssignments === undefined) {
          this.editorAssignments[editor] = payload.output.assignments[editor];
        } else {
          this.editorAssignments[editor] = {
            ...oldEditorAssignments,
            ...payload.output.assignments[editor],
          };
        }
        this.__emitChange();
      });
    }
  }
}

const instance = new AssignmentStore(AssignmentDispatcher);
export default instance;



// WEBPACK FOOTER //
// ./src/stores/AssignmentStore.ts